// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"353":"c7896577","851":"7bda7a60"}[chunkId] + ".js";
};